import {
  get,
  post,
  put,
  del,
} from '@/utils/request';

const url = 'video-sorts';

export function index({ is_del, is_all, page, size }) {
  return get({
    url,
    data: {
      is_del: is_del ? 1 : 0,
      is_all: is_all ? 1 : 0,
      page,
      size,
    },
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function update(id, data) {
  return put({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
